<template>
  <div class="col-md-6 col-sm-8 col-md-offset-3 col-sm-offset-2">
    <div id="environment-ribbon" :class="'banner-' + getEnvironment()">
      {{ getEnvironmentText() }}
    </div>
    <form method="#" action="#">
      <div class="card" data-background="color" data-color="blue">
        <div class="card-header">
          <h3 class="card-title pull-left">Login</h3>
          <router-link class="btn btn-fill btn-wd pull-right" to="/firsttime"><i class="ti-key"></i> First Time Login</router-link>
        </div>
        <br><br>
        <div class="card-content">
          <div class="form-group">
            <label>User ID</label>
            <input type="text" placeholder="User ID"
            name="userId"
            v-validate="modelValidations.userId"
            v-model="model.userId"
            class="form-control input-no-border">
            <small class="text-danger" v-show="userId.invalid">
                {{ getError('userId') }}
            </small>
          </div>
          <div class="form-group">
            <label>Password</label>
            <div class="input-group">
              <input placeholder="Password"
              :type="!showPassword ? 'password' : 'text'"
              name="password"
              v-validate="modelValidations.password"
              v-model="model.password"
              class="form-control input-no-border">
              <span class="input-group-btn">
                <button @click.prevent="showPassword=!showPassword" type="button" tabindex="-1" class="btn form-btn"
                v-html="passwordButton" >
                </button>
              </span>
            </div>
            <small class="text-danger" v-show="password.invalid">
                {{ getError('password') }}
            </small>
          </div>
        </div>
        <div class="card-footer text-center">
          <button :disabled="loading" @click.prevent="validate" type="submit" class="btn btn-fill btn-wd"><i class="ti-lock"></i> Sign In</button>
          <br>
          <span v-if="loading"><i class="fa fa-spinner fa-pulse"></i> Signing in...</span>
          <br>
          <transition name="fade" mode="out-in"><p class="alert alert-danger" v-if="serverError">{{ serverError }}</p></transition>
          <div class="row">
            <div class="col-md-12">
              <router-link to="/recoveraccount">
                <i class="ti-help-alt"></i> Forgot User ID or Password
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate'
import viewClientMethod from 'src/components/Dashboard/Views/Dashboard/ViewClient'
import accountSelectorMethod from 'src/components/Dashboard/Views/Home/Forms/AccountSelector'

export default {
  computed: {
    ...mapFields(['userId', 'password']),
    passwordButton () {
      return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
    }
  },
  data () {
    return {
      showPassword: false,
      loading: false,
      serverError: false,
      model: {
        userId: '',
        password: ''
      },
      modelValidations: {
        userId: {
          required: true,
          alpha_num: true
        },
        password: {
          required: true
        }
      }
    }
  },
  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.serverError = false
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.$emit('on-submit', this.model)
          this.$http.post('/client/login', this.model)
            .then(response => {
              if (response.data.authenticated) {
                if (response.data.accounts) {
                  this.accountSelector(response.data.accounts)
                } else {
                  this.$gtag.set('user_properties',
                    {
                      user_id: 'c' + response.data.clientData.ClientId,
                      group_name: response.data.clientData.GroupName
                    })
                  this.viewClient(response.data)
                }
              } else {
                this.serverError = response.data.error
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    viewClient: viewClientMethod,
    accountSelector: accountSelectorMethod
  },
  created: function () {
    this.viewClient = this.viewClient.bind(this)
    this.accountSelector = this.accountSelector.bind(this)
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home/Forms/Login.vue